import { Directive, TemplateRef, inject, ViewContainerRef, input } from '@angular/core';
import { takeUntilDestroyed, toObservable } from '@angular/core/rxjs-interop';
import { combineLatest, distinctUntilChanged, map, startWith } from 'rxjs';
import { Role } from '@auth/models/role';
import { UserInfo } from '@core/services/user-info';

@Directive({
  selector: '[m4wRolePermission]',
  standalone: true,
})
export class RolePermission {
  private readonly templateRef = inject(TemplateRef<unknown>);
  private readonly userInfo = inject(UserInfo);
  private readonly viewContainer = inject(ViewContainerRef);

  public readonly m4wRolePermission = input<Role[]>([]);

  public constructor() {
    combineLatest([this.userInfo.user$, toObservable(this.m4wRolePermission)])
      .pipe(
        map(
          ([user, requiredRoles]) =>
            requiredRoles.length === 0 || (user !== null && requiredRoles.some((role) => user.roles.includes(role))),
        ),
        startWith(false),
        distinctUntilChanged(),
        takeUntilDestroyed(),
      )
      .subscribe((hasAccess) => {
        this.viewContainer.clear();
        if (hasAccess) {
          this.viewContainer.createEmbeddedView(this.templateRef);
        }
      });
  }
}
